import { updateCurrentCompanyInStore } from "@/helpers";

export default function updateCompanyInStore()
{
    updateCurrentCompanyInStore();
}
